import classes from 'classnames';
import { SlotProps } from 'input-otp';
import styles from './OTP.module.scss';

function Slot({ char, isActive, isError }: SlotProps & { isError?: boolean }) {
  return (
    <div
      className={classes(styles.slot, {
        [styles.active]: isActive,
        [styles.error]: isError,
      })}
    >
      {char !== null && <div>{char}</div>}
    </div>
  );
}

export default Slot;
